import update from "immutability-helper";
import React from "react";

import {updateSurvey} from "../../../../api/SurveyAPI.js";
import ButtonLight from "../../../buttons/ButtonLight.js";
import DeleteButton from "../../../buttons/DeleteButton.js";
import CardButton from "../../../card/CardButton.js";
import Form from "../../../forms/Form.js";
import FormInput from "../../../forms/FormInput.js";
import FormSelect from "../../../forms/FormSelect.js";
import FormSubmit from "../../../forms/FormSubmit.js";
import useFormKey from "../../../forms/useFormKey.js";
import PrimaryHeading from "../../../header/PrimaryHeading.js";
import RegularHeading from "../../../header/RegularHeading.js";
import styles from './SurveyEditor.module.css'

const EditorInput = ({...props}) => {
    return <FormInput uncontrolled noMargin {...props}/>
}

const SurveyEditor = ({ surveyId, sections, onChange }) => {
    const formKey = useFormKey()
    const onSubmit = (values, done) => updateSurvey(surveyId, sections).then(() => done()).catch(done)

    const makeId = () => Math.round(Math.random() * Number.MAX_SAFE_INTEGER)
    const edit = (spec) => onChange(prev => update(prev, spec));

    const addSection = () => edit({ $push: [{ id: makeId(), questions: [] }]})
    const addQuestion = (idx) => edit({ [idx]: { questions: { $push: [{ id: makeId() }]}}})

    const deleteSection = (idx) => edit({$splice: [[idx, 1]]})
    const deleteQuestion = (idx, qIdx) => edit({ [idx]: { questions: { $splice: [[qIdx, 1]]}}})

    const editSection = (idx, key, val) => edit({ [idx]: { [key]: { $set: val }}})
    const editQuestion = (idx, qIdx, key, val) => edit({ [idx]: { questions: { [qIdx]: { [key]: { $set: val }}}}})

    return (
        <Form formKey={formKey} onSubmit={onSubmit}>
            <RegularHeading>Questionário de Satisfação</RegularHeading>

            {sections.map((section, idx) => (
                <section key={section.id} className={styles.section}>
                    <PrimaryHeading>
                        <span>Secção {idx + 1}</span>
                        <DeleteButton onDelete={() => deleteSection(idx)} positionRight/>
                    </PrimaryHeading>
                    <EditorInput value={section.title} placeholder="Título" onChange={val => editSection(idx, "title", val)}/>
                    <EditorInput value={section.description} placeholder="Descrição" onChange={val => editSection(idx, "description", val)}/>
                    {section.questions.map((question, qIdx) => (
                        <div key={question.id} className={styles.question}>
                            <FormSelect values={["1-5", "1-10", "open"]} value={question.type} placeholder="Tipo" uncontrolled noMargin
                                        labels={["1-5", "1-10", "Aberta"]} onChange={val => editQuestion(idx, qIdx, "type", val)}/>
                            <EditorInput value={question.question} placeholder="Pergunta" onChange={val => editQuestion(idx, qIdx, "question", val)}/>
                            <DeleteButton onDelete={() => deleteQuestion(idx, qIdx)}/>
                        </div>
                    ))}
                    <CardButton onClick={() => addQuestion(idx)}>Adicionar Opção</CardButton>
                </section>
            ))}
            <ButtonLight onClick={addSection} fill>Adicionar Secção</ButtonLight>

            <FormSubmit successMessage="Operação concluída" style={{ margin: "auto", minWidth: "40%"}}>
                Atualizar Questionário
            </FormSubmit>
        </Form>
    )
}

export default SurveyEditor;